import { useState } from 'react';
import { AdminConfirmDialog } from '@/components/shared/AdminConfirmDialog';
import { Button } from '@/components/ui/button';
import { formatDateTime } from '@/lib/format-es';
import { useStoreWebPublish } from './useStoreWebPublish';
import { webPublishCopy } from './webPublishCopy';

export function StoreWebPublishBanner() {
    const { query, request } = useStoreWebPublish();
    const [confirm, setConfirm] = useState(false);
    const row = query.data;
    if (!row) return null;
    const copy = webPublishCopy(row, row.lastFinishedAt ? formatDateTime(row.lastFinishedAt) : '');
    const publishing = row.lastState === 'queued' || row.lastState === 'running' || request.isPending;

    return (
        <section className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-border bg-card px-4 py-3">
            <p className="max-w-3xl text-sm text-muted-foreground">{copy.text}</p>
            <Button type="button" size="sm" variant="outline" onClick={() => setConfirm(true)} disabled={publishing}>
                Publicar en la web ahora
            </Button>
            <AdminConfirmDialog
                open={confirm}
                title="Publicar en la web ahora"
                description="Se lanza el pipeline de la landing sin esperar los 10 minutos de agrupación. Tarda unos 15 minutos. No envía ningún correo."
                confirmLabel="Publicar"
                confirmDisabled={publishing}
                onConfirm={() => {
                    setConfirm(false);
                    request.mutate();
                }}
                onCancel={() => setConfirm(false)}
            />
        </section>
    );
}
